import React from "react";
// COMPONENTS
import SitePageShell from "Components/WebsiteTheme/SitePageShell";
import SiteCtaBand from "Components/WebsiteTheme/SiteCtaBand";
import PageHeading from "Components/PageHeading/PageHeading";
import { DEMO_BAND } from "Components/WebsiteTheme/site.data";
import SubjectsIntro from "./SubjectsIntro";
import SubjectsOverview from "./SubjectsOverview";

/** Subjects page, in the Home and About page style (same header, text, cards, buttons and footer). */
const SubjectsDashboard = () => (
	<SitePageShell className="subjects_page">
		<PageHeading
			tone="site"
			title={
				<>
					Our <span className="sm_accent">Subjects</span>
				</>
			}
			breadcrumbs={[{ label: "Home", path: "/" }, { label: "Subjects" }]}
		/>
		<SubjectsIntro />
		<SubjectsOverview />
		<SiteCtaBand title={DEMO_BAND.title} text={DEMO_BAND.text} />
	</SitePageShell>
);

export default SubjectsDashboard;
